import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText } from "vue"

const _hoisted_1 = { class: "tw-border-[2px] tw-border-[#d2d2d2] tw-mt-5 tw-mb-5 tw-rounded-xl tw-overflow-hidden tw-text-left" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-bg-[#00a0da] tw-text-white tw-px-4 tw-pt-2.5 tw-pb-2 tw-text-xl tw-font-semibold" }, " PROPERTY INFORMATION ", -1)
const _hoisted_3 = { class: "tw-px-4 tw-mb-[25px]" }
const _hoisted_4 = { class: "tw-flex tw-justify-between tw-items-center tw-mt-3 tw-gap-5" }
const _hoisted_5 = { class: "tw-w-full" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "STATE", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("option", {
  value: null,
  selected: ""
}, "Choose...", -1)
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "tw-w-full" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "COUNTY", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("option", {
  value: null,
  selected: ""
}, "Choose...", -1)
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "tw-w-full" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "PROPERTY ADDRESSES", -1)
const _hoisted_15 = { class: "tw-w-full" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "ZIP-CODE", -1)

import { ref, toRefs } from 'vue'
import UserService from '@/shared/services/user.service';
import { useToast } from "@/composables/useToast";

export default /*#__PURE__*/_defineComponent({
  __name: 'PropertyInformation',
  props: {
  propertyState: {
    type: String,
    default: ''
  },
  propertyCounty: {
    type: String,
    default: ''
  },
  propertyAddresses: {
    type: String,
    default: ''
  },
  propertyZipCode: {
    type: String,
    default: ''
  }
},
  emits: ['update:propertyState', 'update:propertyCounty', 'update:propertyAddresses', 'update:propertyZipCode'],
  setup(__props, { emit }) {

const props = __props;

const toast = useToast();




const { propertyState, propertyCounty, propertyAddresses, propertyZipCode } = toRefs(props)

const estate = ref(null)
const county = ref(null)
const address = ref('')
const zipCode = ref('')

const loading = ref(false)
const listStates = ref([])
const listCounties = ref([])

const getStates = async () => {
  loading.value = true
  const response = (await UserService.getZoneStates()).data
  if (!response.error) {
    let list: any = response.data
    listStates.value = list
  } else {
    await toast.error(`Error loading states`, {
      position: "top-end",
      timer: 3000,
      showCloseButton: true,
    });
  }
  loading.value = false
}

const getCounties = async () => {
  loading.value = true;
  emit('update:propertyState', estate.value)
  let state: any = estate.value;
  const response = (await UserService.getCounty(state)).data

  if (!response.error) {
    let list: any = response.data
    if (list.length > 0) {
      listCounties.value = list.filter((a: any) => a.length > 0);
    };
  }
  else {
    await toast.error(`Error loading countries`, {
      position: "top-end",
      timer: 3000,
      showCloseButton: true,
    });
  }

  loading.value = false
}

const updateProperty = () => {
  emit('update:propertyState', estate.value)
  emit('update:propertyCounty', county.value)
  emit('update:propertyAddresses', address.value)
  emit('update:propertyZipCode', zipCode.value)
}

getStates()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _withDirectives(_createElementVNode("select", {
              name: "",
              id: "",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((estate).value = $event)),
              class: "tw-w-full tw-outline-none tw-h-[45px] tw-border tw-border-[#b6b6b6] tw-rounded-lg tw-overflow-hidden tw-px-1 tw-cursor-pointer tw-mt-2",
              onChange: _cache[1] || (_cache[1] = ($event: any) => (getCounties()))
            }, [
              _hoisted_7,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listStates.value, (state) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: state.name
                }, _toDisplayString(state.name), 9, _hoisted_8))
              }), 256))
            ], 544), [
              [_vModelSelect, estate.value]
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _withDirectives(_createElementVNode("select", {
              name: "",
              id: "",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((county).value = $event)),
              onChange: updateProperty,
              class: "tw-w-full tw-outline-none tw-h-[45px] tw-border tw-border-[#b6b6b6] tw-rounded-lg tw-overflow-hidden tw-px-1 tw-cursor-pointer tw-mt-2"
            }, [
              _hoisted_11,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listCounties.value, (country) => {
                return (_openBlock(), _createElementBlock("option", { value: country }, _toDisplayString(country), 9, _hoisted_12))
              }), 256))
            ], 544), [
              [_vModelSelect, county.value]
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              name: "",
              id: "",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((address).value = $event)),
              onChange: updateProperty,
              class: "tw-w-full tw-outline-none tw-h-[45px] tw-border tw-border-[#b6b6b6] tw-rounded-lg tw-overflow-hidden tw-px-4 tw-mt-0.5"
            }, null, 544), [
              [_vModelText, address.value]
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _withDirectives(_createElementVNode("input", {
              name: "",
              id: "",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((zipCode).value = $event)),
              onChange: updateProperty,
              class: "tw-w-full tw-outline-none tw-h-[45px] tw-border tw-border-[#b6b6b6] tw-rounded-lg tw-overflow-hidden tw-px-4 tw-mt-0.5"
            }, null, 544), [
              [_vModelText, zipCode.value]
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})